import moment from 'moment';
import React, { useState } from 'react';
import { decryptData } from '../../../utils/helper';
import { useNavigate } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { Row } from 'reactstrap';
import AddTask from './AddTask';
import { FormControl, MenuItem, Select } from '@mui/material';
import { stageStatusOption, statusTaskOptions } from '../Constant';
import { createApplicationActivity, deleteTask, updateTask } from '../../../api/Applications';
import { failed, success } from '../../../utils/Tostify';
import Loader from '../../../components/Loader/Loader';
import { useConfirmDialog } from '../../../hooks/useConfirmDialog';
import { ActivityDetails, platformLayout } from '../../../utils/constants';
import AddApplicationDocumentModal from '../Documents/AddDocument';
import PdfViewer from '../../../components/PdfViewer/PdfViewer';
import "../../activity/index.css";
import { uploadOrUpdateDocument } from '../../../api/patient';
import { handleFileUpload } from '../../../utils/ImageToBase64';

const Tasks = ({application, getApplication}) => {

    const navigate = useNavigate();
    const dispatch  = useDispatch();
    const [modelShow, setShowModel] = useState(false);
    const [taskData, setTaskData] = useState({});
    let token = useSelector(state => state.userReducer.token);
    let role = localStorage.getItem("userRole");
    const isPatient = role === "Patient";
    const [isLoading, setIsLoading] = useState(false);
    const { getConfirmation } = useConfirmDialog();
    const [pdfUrl, setPdfUrl] = useState("");
    const [formData, setFormData] = useState({});
    const [showPdfViewModal, setShowPdfViewModal] = useState(false);
    const [showDocModal, setShowAddDocModal] = useState(false);
    const [applicationId, setapplicationId] = useState("");
    const [taskId, setTaskId] = useState("");
    const user = useSelector((state) => state?.userReducer?.user);

    const toggleModal = ()=>{
      setShowModel(false);
      setTaskData({});
     };

    const handleSaveClick = async(taskId, data) =>{
    let res;
    try {
      const payload = {tasks : data  };
      setIsLoading(true);
      res = await updateTask({values:payload, dispatch, token, applicationId: application?._id, taskId: taskId});
      if (res?.status === "SUCCESS") {
        let values = {
          type : "Application",
          event : ActivityDetails?.TaskCreationUpdate?.event,
          applicationId : application?._id,
          clinicId: localStorage.getItem("currentHospitalId"),
          organizationId: localStorage.getItem("currentOrgId"),
          patientId : application?.patientData?._id ,
          details : "Task status changed."
        };
        await createApplicationActivity({ values, dispatch, token });
        await getApplication();
        setIsLoading(false);
        success(res?.message);
      }
    } catch (error) {
      failed(res?.message);
      setIsLoading(false);
    }
    };

    const handleRemoveTask = async(id) =>{
      const confirmed = await getConfirmation({
        title: "Attention!",
        entryName: "",
        actionBtnTitle: "Yes",
        message: `Are you sure you want to delete task?`
      });
      if (confirmed) {
          let res;
          try {
              const values = {applicationId: application?._id , taskId: id};
              setIsLoading(true);
              res = await deleteTask({values, dispatch, token});
              if (res?.status === "SUCCESS") {
                  setIsLoading(false);
                  await getApplication();
                  success(res?.message);
              } else {
                  setIsLoading(false);
                  failed(res?.message);
              }
          } catch (error) {
              setIsLoading(false);
              failed(res?.message);
          }
        }
      };

  const triggerFileInputDoc = (appId, taskId, index) => {
    setapplicationId(appId); // Trigger file input
    // setShowAddDocModal(true);
    document.getElementById(`fileInputDoc-${appId}-${taskId}-${index}`)?.click();
    setTaskId(taskId);
  };


    const handleDocUpdate = async(file, docId, taskId) => {
      let res;
      try {
        let base64pdfForm = "";
            base64pdfForm = await handleFileUpload(file);
            const fileExtension = file?.type?.split("/")[1];
            const docFile = {
                base64String: base64pdfForm,
                extension: fileExtension, // Add the file extension to the object
                name: file?.name
            };
            const payload = {file : docFile};
        setIsLoading(true);
        res = await uploadOrUpdateDocument({ values : payload, dispatch, token, patientId: application?.patientData?._id, documentId : docId, uploadedBy:user._id ,applicationId: application?._id, type: "task"});
        if (res?.status === "SUCCESS") {
          let values = {
            type : "Application",
            event : ActivityDetails?.DocumentUploadDownload?.event,
            applicationId : application?._id,
            clinicId: localStorage.getItem("currentHospitalId"),
            organizationId: localStorage.getItem("currentOrgId"),
            patientId :  application?.patientData?._id,
            details : "Document Uploaded."
          };
          const payload = {tasks : { status : "Completed"}  };
          await updateTask({values:payload, dispatch, token, applicationId: application?._id, taskId});
          await createApplicationActivity({ values, dispatch, token });
          await getApplication();
          success(res.message);
          setIsLoading(false);
        }else{
          setIsLoading(false);
          failed(res?.message);
        }
      } catch (error) {
        // console.log(error);
        failed(res?.message);
        setIsLoading(false);
      }
    };

    const handleFileSelect = (event,taskId, docId) => {
      const file = event.target.files[0];
      if (file) {
        (file);
          handleDocUpdate(file, docId, taskId);
      }
    };

  return (
    <div className="data_patient table_listing_color">
    {isLoading ? <Loader /> : null}
    <div className=" application_details_block mt-3 mb-3">
      <Row>
        <h3 className="title_name mt-0">Application Overview</h3>
        <div className="col-xl-4 col-lg-4 application_details">
                            <div className="row">
                              <div className="col-3 text-end"><p>Start Date</p></div>
                              <div className="col-1 text-center"><p>:</p></div>
                              <div className="col-8"><p>{moment(application?.createdAt).format("MMM-DD-YYYY")}</p></div>
                            </div>
                          </div>

                          <div className="col-xl-4 col-lg-6 application_details">
                          <div className="row">
                            <div className="col-4 text-end"><p>Application Type</p></div>
                            <div className="col-1 text-center"><p>:</p></div>
                            <div className="col-7"><p>{application?.applicationType?.applicationTitle}</p></div>
                          </div>
                        </div>

                        <div className="col-xl-4 col-lg-6 application_details">
                          <div className="row">
                            <div className="col-4 text-end"><p>Application Status</p></div>
                            <div className="col-1 text-center"><p>:</p></div>
                            <div className="col-7"><p>{stageStatusOption.find(option => option.value === application?.status)?.label || '-'}</p></div>
                          </div>
                        </div>

                        <div className="col-xl-4 col-lg-6 application_details">
                          <div className="row">
                            <div className="col-3 text-end"><p>Active Days</p></div>
                            <div className="col-1 text-center"><p>:</p></div>
                            <div className="col-7">
                              <p>
                                {moment().diff(moment(application?.createdAt), "days") + " Days"}
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="col-xl-4 col-lg-6 application_details">
                          <div className="row">
                            <div className="col-4 text-end"><p>Consultant</p></div>
                            <div className="col-1 text-center"><p>:</p></div>
                            <div className="col-7">
                              <p>
                                {application.consultantUser?.[0]
                                  ? `${application.consultantUser?.[0]?.firstName} ${application.consultantUser?.[0]?.lastName}`
                                  : "No Consultant assigned."}
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="col-xl-4 col-lg-6 application_details">
                          <div className="row">
                            <div className="col-4 text-end"><p>Application Id</p></div>
                            <div className="col-1 text-center"><p>:</p></div>
                            <div className="col-7"><p>{application?.applicationID}</p></div>
                          </div>
                        </div>
      </Row>
      {role !== platformLayout?.Patient &&  <Row className="mt-3 align-items-center">
                        <h3 className="title_name mt-1">Primary Applicant</h3>

                        <div className="col-xl-4 col-lg-6 application_details">
                          <div className="row">
                            <div className="col-3 text-end"><p>Name</p></div>
                            <div className="col-1 text-center"><p>:</p></div>
                            <div className="col-7">
                              <p>
                                {decryptData(application?.patientData?.name[0].text)}{" "}
                                <button
                                  className="add_notes"
                                  onClick={() =>
                                    navigate("/clinic/patient-profile", {
                                      state: { patientData: application?.patientData?._id, isEditMode: true}
                                    })
                                  }
                                >
                                  View Details
                                </button>
                              </p>
                            </div>
                          </div>

                          <div className="row mt-2">
                            <div className="col-3 text-end"><p>Email ID</p></div>
                            <div className="col-1 text-center"><p>:</p></div>
                            <div className="col-7">
                              <p>
                                {decryptData(
                                  application?.patientData?.telecom.find((obj) => obj?.system === "email")
                                    ?.value || "-"
                                )}
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="col-xl-4 col-lg-6 application_details">
                          <div className="row">
                            <div className="col-4 text-end"><p>Gender</p></div>
                            <div className="col-1 text-center"><p>:</p></div>
                            <div className="col-7">
                              <p>{decryptData(application?.patientData?.gender) || "-"}</p>
                            </div>
                          </div>

                          <div className="row mt-2">
                            <div className="col-4 text-end"><p>Status</p></div>
                            <div className="col-1 text-center"><p>:</p></div>
                            <div className="col-7">
                              <p>{decryptData(application?.patientData?.maritalStatus) || "-"}</p>
                            </div>
                          </div>
                        </div>

                        <div className="col-xl-4 col-lg-6 application_details">
                          <div className="row">
                            <div className="col-4 text-end"><p>DOB</p></div>
                            <div className="col-1 text-center"><p>:</p></div>
                            <div className="col-7">
                              <p>{decryptData(application?.patientData?.birthDate) || "-"}</p>
                            </div>
                          </div>

                          <div className="row mt-2">
                            <div className="col-4 text-end"><p>State</p></div>
                            <div className="col-1 text-center"><p>:</p></div>
                            <div className="col-7">
                              <p>
                              {application.patientData?.address[0].state && decryptData(application.patientData?.address[0].state)}
                              </p>
                            </div>
                          </div>
                        </div>
                      </Row>}
    </div>
    <h6 className="form_name list_blk mt-3 mb-3 ">Tasks: </h6>
    <div className="table_space table_listing_color">
      <div className="table-responsive">
        <table>
        <thead>
            <tr className="header_table">
              <th></th>
              <th>Task</th>
              <th>Assigned To</th>
              <th>Assigned By</th>
              <th>Type</th>
              <th>Status</th>
              <th>Due Date</th>
              <th>Actions</th>
            </tr>
          </thead>
            <tbody>
            {application?.tasks?.length > 0 ? (
              application?.tasks?.map((task, index) => (
                <>
                <tr className={index % 2 === 0 ? 'first_block' : 'second_block'}>
                  <td>{index + 1 }</td>
                  <td>{task?.title}</td>
                  {/* <td>{task?.assignedToUser?.firstName + " " + task?.assignedToUser?.lastName}</td> */}
                  <td>
                    {task?.assignedToPatient?.firstName?.[0]?.text
                      ? decryptData(task.assignedToPatient.firstName[0].text)
                      : task?.assignedToUser?.firstName || task?.assignedToUser?.lastName
                        ? `${task?.assignedToUser?.firstName || ""} ${task?.assignedToUser?.lastName || ""}`.trim()
                        : ""}
                  </td>
                  <td>{task?.assignedByUser?.firstName + " " + task?.assignedByUser?.lastName}</td>
                  <td className="p-0">
                  Task
                  </td>
                  <td className="p-0 upload_blk">
                    {isPatient ? (
                      <span style={{ padding: "0.5rem 1rem", display: "inline-block" }}>
                        {
                          statusTaskOptions.find((option) => option.value === task?.status)?.label || "-"
                        }
                      </span>
                    ) : (
                      <FormControl sx={{ m: 1, minWidth: 80 }} size="small">
                        <Select
                          labelId="demo-select-small-label"
                          id="demo-select-small"
                          value={task?.status}
                          defaultValue={task?.status}
                          onChange={(e) => handleSaveClick(task._id, { status: e.target.value })}
                        >
                          {statusTaskOptions?.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                              {option.label}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}
                  </td>

                  <td>{ task?.dueDate ? moment(task?.dueDate).format("DD-MM-YYYY") : "NA"}</td>
                  <td>
                    {!isPatient ? (
                      <div className='d-flex gap-2 align-items-center'>
                        <i
                          className="fa fa-pencil"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            setShowModel(true);
                            setTaskData(task);
                          }}
                        ></i>
                        <i
                          className="fas fa-trash-alt"
                          style={{ cursor: "pointer" }}
                          onClick={() => handleRemoveTask(task?._id)}
                        ></i>
                      </div>
                    ) : (
                      <>
                        {/* {task?.taskAction === "Upload Document" ? (
                          <button
                            className="schedule_btn"
                            onClick={() => triggerFileInputDoc(task?.applicationId)}
                          >
                            Upload
                          </button>
                        ) : (
                          <button
                            className={`${task?.status === "Completed" ? "details" : "schedule_btn"}`}
                            onClick={() => {
                              setShowPdfViewModal(true);
                              setPdfUrl(task?.formSignedUrl);
                              setFormData(task);
                            }}
                          >
                            {task?.status === "Completed"
                            ? "View"
                            : task?.taskAction === "Sign Form"
                            ? "Sign"
                            : task?.taskAction === "Verify Form"
                            ? "Verify"
                            : task?.taskAction === "Update Form"
                            ? "Update"
                            : "View"}
                          </button>
                        )} */}
                        {task?.taskAction === "Upload Document" ? (
                          task?.status === "Completed" ? (
                            <button
                              className="details"
                              onClick={() => {
                                setShowPdfViewModal(true);
                                setPdfUrl(task?.signedUrl  || task?.documentDetails?.filePath?.signedUrl ); // ✅ Use signedUrl (not formSignedUrl) for "Upload Document"
                                setFormData(task);
                              }}
                            >
                              View
                            </button>
                          ) : (
                           <>
                            <button
                              className="schedule_btn"
                              onClick={() => triggerFileInputDoc(task?.applicationId, task?._id, index)}
                            >
                              Upload
                            </button>
                            <input
                              type="file"
                              id={`fileInputDoc-${task?.applicationId}-${task?._id}-${index}`}
                              style={{ display: "none" }}
                              onChange={(e) =>
                                handleFileSelect(e, task?._id, task?.documentId)
                              }
                            />
                          </>
                          )
                        ) : (
                          <button
                            className={`${task?.status === "Completed" ? "details" : "schedule_btn"}`}
                            onClick={() => {
                              setShowPdfViewModal(true);
                              setPdfUrl(task?.formSignedUrl);
                              setFormData(task);
                            }}
                          >
                            {task?.status === "Completed"
                              ? "View"
                              : task?.taskAction === "Sign Form"
                              ? "Sign"
                              : task?.taskAction === "Verify Form"
                              ? "Verify"
                              : task?.taskAction === "Update Form"
                              ? "Update"
                              : "View"}
                          </button>
                        )}
                      </>
                    )}
                  </td>
                </tr>
              </>
              ))
            ) : (
              <tr>
                <td colSpan={10}>
                  <p className="text-center">No Data Found</p>
                </td>
              </tr>
            )}
            </tbody>
        </table>
      </div>
      {showDocModal ? <AddApplicationDocumentModal refetch={()=>{}} status={"Completed"}  taskId={taskId} setShowModal={()=> setShowAddDocModal(!showDocModal)} applicationId={applicationId}/> : null}
      {showPdfViewModal ? <PdfViewer url={pdfUrl} type="task" refetch={getApplication} formData={formData} setShowModal={()=> !setShowPdfViewModal(!showPdfViewModal)}/> : null}
      <AddTask
        isOpen={modelShow}
        application={application}
        getApplication={getApplication}
        toggle={toggleModal}
        taskData={taskData}
      />
    </div>
    {role !== platformLayout?.Patient && (
      <div className="d-flex justify-content-center mt-3">
        <button
          className="add_document"
          onClick={() => setShowModel(true)}
          disabled={!(application?.status === "InProcess" && !application?.archieve)}
        >
          Schedule Task
        </button>
      </div>
    )}
  </div>
  );
};

export default Tasks;
